import UserResource from "../../resources/user-resource"

export const makeUserResource = (): UserResource => {
    return new UserResource()
}
